import { css } from 'styled-components';
import { fontWeights, standardColours } from '../variables';
import { fontSize } from './FontSizes';

export const labelStyles = () => {
  return css`
    display: block;
    margin-bottom: 10px;
    font-weight: ${fontWeights.medium};
  `;
};

export const popUpLabelStyles = () => {
  return css`
    display: block;
    margin-bottom: 10px;
    font-weight: ${fontWeights.medium};
    ${fontSize(14)};
  `;
};

export const inputStyles = () => {
  return css`
    border: none;
    width: 100%;
    padding: 15px;
  `;
};

export const popUpInputStyles = () => {
  return css`
    border: none;
    width: 100%;
    padding: 10px;
    ${fontSize(14)};
  `;
};

export const selectWrapStyles = () => {
  return css`
    position: relative;

    &:after {
      content: '';
      position: absolute;
      color: ${standardColours.black};
      top: 50%;
      right: 12px;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid ${standardColours.black};
      pointer-events: none;
      transform: translateY(-50%);
    }
  `;
};

export const selectStyles = () => {
  return css`
    cursor: pointer;
    appearance: none;
    padding-right: 40px;
    padding-left: 15px;
    height: 60px;
    background: ${standardColours.white};
    border: 1px solid ${standardColours.lightestGrey};
  `;
};
